module.exports = __webpack_public_path__ + "static/media/icon.e7cc5ad2.png";